import { render, staticRenderFns } from "./StatisticList.vue?vue&type=template&id=5dd0565e&scoped=true&"
import script from "./StatisticList.vue?vue&type=script&lang=ts&"
export * from "./StatisticList.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticList.vue?vue&type=style&index=0&id=5dd0565e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0565e",
  null
  
)

export default component.exports